import React, { memo } from 'react';
import Carousel from './components/Carousel';
import DropDown from './components/DropDown/DropDown';
import useMenuRedirect from './hooks/useMenuRedirect';

export const SubMenu = () => {
  const { nodesSelected, getTypeSubmenu } = useMenuRedirect();
  const type = getTypeSubmenu();

  const renderSubMenu = () => {
    switch (type) {
      case 'DROPDOWN':
        return <DropDown />;
      case 'CAROUSEL':
        return <Carousel dataSubmenu={nodesSelected.childs} />;

      default:
        return null;
    }
  };

  return <> {renderSubMenu()}</>;
};

export default memo(SubMenu);
